<template>
  <article class="articles-card" :class="singleCard && 'single-card'">
    <div class="image">
      <img :src="item.field_image" :alt="item.alt" itemprop="image" />
    </div>
    <div class="text-wrapper" v-if="singleCard">
      <time v-if="item.date_created" class="date" :datetime="item.date_created">{{ item.date_created }}</time>
      <h3>{{ strippedContent(item.title) }}</h3>
      <p>{{ strippedContent(item.body) }}</p>
      <a class="button" :href="item.url" :title="item.title" >
        {{ labelButton }}
      </a>
    </div>
    <div class="text-wrapper" v-else>
      <time v-if="item.date_created" class="date" :datetime="item.date_created">{{ item.date_created }}</time>
      <h3 class="h4">
        <a :href="item.url" :title="item.title">
          {{ strippedContent(item.title) }}
        </a>
      </h3>
      <p>{{ strippedContent(item.body) }}</p>
    </div>

  </article>
</template>

<script type="javascript">
export default {
  props: {
    readingTime: {
      default: "",
    },
    item: {
      default: {},
    },
    singleCard: {
      default: false,
    },
  },
  computed: {
    labelButton() {
      return Drupal.t('Read more');
    },
  },
  methods: {
    strippedContent: function (string) {
      const div = document.createElement("div");
      div.innerHTML = string;
      const text = div.textContent || div.innerText || "";
      return text;
      // return string.replace(/<\/?[^>]+>/ig, " ");
    },
  },
};
</script>
